import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastService } from '../../shared/toast.service'
import { ReportingService } from '../../views/reporting/reporting.service';
import { AccountingService } from '../../views/accounting/accounting.service';
import { AccrualGeneralJournal, AccrualGeneralJournalEntry, AccrualGeneralJournalEntryType } from './accrual-general-journal.model';

@Component({
	selector:    'send-accrual-to-intacct',
	//styleUrls:  ['./send-accrual-to-intacct.component.css'], 
	templateUrl: './send-accrual-to-intacct.component.html'
})

export class SendAccrualToIntacctComponent implements OnInit {
	@Input() accrualData: AccrualGeneralJournal;
	@Input() billingPeriod: Date;
	@Input() showSendAccrualPanel: boolean;
	@Output() onClosed = new EventEmitter();

	intacctResponse: any[];
	sendingRequestToIntacct: boolean;
	lockActions = false;
	processingPeriod: Date;
	sendAccrualInProgress = false;
	isInitDataLoading: boolean;
	isSentToIntacct: boolean;
	showIntacctResponseSidePanel = false;
	showSendToIntactPanel: boolean;
	canClosePannel = true;
	glPostingDate: Date;
	minGLPostingDate: Date;
	maxAllowedDate: Date;
	glReverseDate: Date;
	attachmentFolderName: string;
	memo: string;

	constructor(
		private reportService: ReportingService,
		private accountingService: AccountingService,
		private toaster: ToastService) {
	}

	ngOnInit() {
		if (!this.accrualData) {
			this.toaster.error("Send-Accrual-to-Intacct Component Implementation Error", "The input Parameter: accrualData can not be null!");
		} 
		
		this.isInitDataLoading = true;
		this.accountingService.getOpenPeriodStart().subscribe(x => {
			this.glPostingDate = new Date(x);
			let revsDate= new Date(x);
			this.glReverseDate = new Date(revsDate.setMonth(revsDate.getMonth()+3));
			this.isInitDataLoading = false
		
			}, (error) => {this.toaster.error("Get Intacct GlPosting date failed", error);
			this.isInitDataLoading = false;
		});

		this.setAccrualEntryCreditDebit();
	}

	get disableSendToIntacct(): boolean {
		return !this.processingPeriod || this.lockActions;
	}

	public sendAccrualToIntacct() {
		this.sendAccrualInProgress = true;
		this.accrualData.journalReverseDate = this.glReverseDate.toDateString();
		this.accrualData.entries.forEach(x=>x.memo = this.memo);
		this.intacctResponse = [];
		this.reportService.SendAccrualToIntacct(this.accrualData).subscribe(response => {
			this.showIntacctResponseSidePanel = true;
			this.isSentToIntacct = true;
			this.intacctResponse = response.item2.map( x=> {return { message: x };});
			this.sendAccrualInProgress = false;
		},
		errorResult => {
			this.sendAccrualInProgress = false;
			this.toaster.error(errorResult.error.Message, 'Error sending {this.accrualData.accrualType} ');
		});
	}

	public closeComponent() {
		this.showSendAccrualPanel = false;
		this.showIntacctResponseSidePanel = false;
		this.onClosed.emit(this.intacctResponse ? this.intacctResponse.map(x => x.message) : []);
	}

	toggleIntacctResponseSidePanel() {
		this.showIntacctResponseSidePanel = !this.showIntacctResponseSidePanel;
	}

	setAccrualEntryCreditDebit()
	{
		this.accrualData.entries.forEach( x=> {
			x.entryType == AccrualGeneralJournalEntryType.glCredit? x.transactionCredit = x.amount : 
			x.entryType == AccrualGeneralJournalEntryType.glDebit? x.transactionDebit = x.amount : null;
		});
	}

	public getMinGLReverseDate()
	{
		return this.glPostingDate;
	}

	private onError(errorResult) {
		this.sendingRequestToIntacct = false;
	}
}
